import { useState } from 'react';
import { useSelector } from 'react-redux';
import { postWithToken } from '../../utilities/fetchWithToken';
import { BASE_URL } from '../../utilities/BASE_URL';
import './gameroom.css';

// label/title vary by table type: on a live tournament table the checkbox is "Sit Away" and maps
// to the away state (still dealt in, still posting blinds, auto check-folding) rather than to
// is_sitting_out — see TableLifecycleService.sitOut.
//
// ONE-DIRECTIONAL: this checkbox only ever PARKS the seat. GameTable removes it entirely while
// the player is sitting out/away (and until they're dealt into a fresh round), and the server
// rejects sittingOut=false outright — rejoining is exclusively the away box's "Rejoin Table"
// button, so the checkbox can never race the rejoin flow.
const SitOutToggle = ({ roomId, label = 'Sit Out', title }) => {
    const [sittingOut, setSittingOut] = useState(false);

    // Anchor to the right edge of the chat window so it never gets covered.
    // Chat window is ~120px wide collapsed / ~240px expanded (left-anchored).
    const chatCollapsed = useSelector(state => state.chatBox.collapsed[roomId] ?? false);
    const leftPx = chatCollapsed ? 132 : 252;

    const handleChange = async (e) => {
        if (!e.target.checked) return; // unchecking is not a rejoin — ignore it
        setSittingOut(true);
        try {
            await postWithToken(`${BASE_URL}/games/sitout`, { roomId, sittingOut: true });
        } catch (err) {
            setSittingOut(false); // revert on error
        }
    };

    return (
        <label className="sit-out-toggle" style={{ left: `${leftPx}px` }} title={title}>
            <input type="checkbox" checked={sittingOut} onChange={handleChange} />
            {label}
        </label>
    );
};

export default SitOutToggle;
